allowProduct